export function formatUsd(cents: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

export function formatLocal(
  usdCents: number,
  exchangeRate: number,
  currency: string,
  decimals: number,
  symbol?: string,
): string {
  const amount = (usdCents / 100) * exchangeRate;
  try {
    return new Intl.NumberFormat('es', {
      style: 'currency',
      currency,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(amount);
  } catch {
    return `${symbol ?? currency} ${amount.toFixed(decimals)}`;
  }
}

export function formatLocalMinor(minor: number, currency: string, decimals: number, symbol?: string): string {
  const amount = minor / 10 ** decimals;
  try {
    return new Intl.NumberFormat('es', {
      style: 'currency',
      currency,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(amount);
  } catch {
    return `${symbol ?? currency} ${amount.toFixed(decimals)}`;
  }
}
